export const ToastTimeout = 4000;
export const HTTPResponse = {
  OK: 200,
  BadRequest: 400,
  Unauthorized: 401,
  NotFound: 404,
  NotAllowed: 405,
  Conflict: 409,
  InternalServerError: 500,
};
export const AppContextIntialState = {
  isLoading: false,
  showToast: false,
  toastMessage: "",
  actionPopUp: {
    isOpen: false,
    title: "Alert",
    description: "Are you sure?",
    confirmButtonLabel: "Yes",
    disableCancelBtn: false,
  },
  toastType: undefined,
  pageDataChanged: false,
  showTopMenu: false,
  mdeNo: null,
  activeTab: undefined,
  showCartPage: true,
  isSideMenuActive: true
};
export const ToastMessageType = {
  Success: 0,
  Failed: 1,
};

export const SettingCare = {
  Inpatient: 'Inpatient visit',
  ICU: 'ICU/NICU visit',
  ER: 'ER visit',
  Outpatient: 'Outpatient visit',
  Other: 'Other',
  Unknown: 'Unknown',
};

export const TopMenuItems = {
  Patients: 1,
  Centers: 2,
  Abstractors: 3,
  Logout: 4,
};

export const SideMenuItems = {
  AbbreviationList: 1,
  PatientScreening: 2,
  EligibilityCriteria: 3,
  Part1: 4,
  Demographics: 5,
  ClinicalCharacteristics: 6,
  TransplantCharacteristics: 7,
  MDEInfoPage: 8,
  MDESForm: 9,
  MDESInformation: 10,
  Hospitalizations: 11,
  MMALabAssessment: 12,
  ValidateSubmit1: 13,
  Part2: 14,
  NonMdeTreatment: 15,
  RenalLabAssessment: 16,
  OtherLabAssessment: 17,
  MmsComplications: 18,
  NutritionManagement: 19,
  ValidateSubmit2: 20,
};

export const SideMenuPageList = [
  { id: 1, title: "**ABBREVIATION LIST", path: "/AbbreviationList", ispartsection: false },
  { id: 2, title: "**PATIENT SCREENING", path: "/PatientScreening", ispartsection: false },
  { id: 3, title: "ELIGIBILITY CRITERIA", path: "/EligibilityCriteria", ispartsection: false },

  { id: 4, title: "PART 1", path: "", incomplete: false, ispartsection: false },
  { id: 5, title: "PATIENT DEMOGRAPHICS", path: "/Demographics", incomplete: false, ispartsection: true },
  { id: 6, title: "CLINICAL CHARACTERISTICS", path: "/ClinicalCharacteristics", incomplete: false, ispartsection: true },
  { id: 7, title: "TRANSPLANT CHARACTERISTICS", path: "/TransplantCharacteristics", incomplete: false, ispartsection: true },
  // { title: "METABOLIC DECOMPENSATION EVENTS (MDES)", notClickable: true },
  { id: 8, title: "**METABOLIC DECOMPENSATION EVENTS (MDEs)", path: "/MDEInfo", ispartsection: true },
  { id: 9, title: "MDEs From [TransplantStartDate] To <br/>[StabilizationDate]", path: "/MDESForm", incomplete: false, ispartsection: true },
  { path: "/MDESInformation", ispartsection: true },
  { id: 11, title: "HOSPITALIZATIONS", path: "/Hospitalizations", incomplete: false, ispartsection: true },
  { id: 12, title: "MMA LAB ASSESSMENTS", path: "/MMALabAssessment", incomplete: false, ispartsection: true },
  { id: 13, title: "VALIDATE & SUBMIT 1", path: "/ValidateSubmit?part=1", ispartsection: false },

  { id: 14, title: "PART 2", path: "", incomplete: false, ispartsection: false },
  { id: 15, title: "NON-MDE TREATMENT CHARACTERISTICS", path: "/NonMDETreatment", incomplete: false, ispartsection: true },
  { id: 16, title: "RENAL LAB ASSESSMENTS", path: "/RenalLabAssessment", incomplete: false, ispartsection: true },
  { id: 17, title: "OTHER LAB ASSESSMENTS", path: "/OtherLabAssessment", incomplete: false, ispartsection: true},
  { id: 18, title: "MMA-RELATED COMPLICATIONS", path: "/MMARelatedComplications", incomplete: false, ispartsection: true },
  { id: 19, title: "NUTRITION MANAGEMENT", path: "/NutritionManagement", incomplete: false, ispartsection: true },
  { id: 20, title: "VALIDATE & SUBMIT 2", path: "/ValidateSubmit?part=2", ispartsection: false },
];

export const AdminOnlyRoutes = [
  "/manageabstractors",
  "/managecenters",
];

export const ToastMessages = {
  Save_Success: "Data has been Successfully saved.",
  Fail: "Oops!, Something went wrong.",
};

export const PageAction = {
  add: 1,
  edit: 2,
};

export const DefaultAGGridProps = {
  ROWS_PER_PAGE: 10,
  ROW_HEIGHT: 50,
  TABLE_HEIGHT: 50 * 10 + 100,
  NOT_FOUND: "No Records Found",
};
export const TableConstants = {
  PAGE_SIZE: 7,
  NOT_FOUND: "No Records Found",
};
export const PageDesignConstants = {
  backgroundColor: "#dff3f6",
  fontColor: "steelblue",
  fontWeight: "bold",
  PageDescriptionStyle: {
    fontWeight: "500",
    paddingBottom: "10px",
    textDecoration: "underline",
    fontStyle: "italic",
  },
};
export const DatePickerDefaultProps = {
  showMonthDropdown: true,
  showYearDropdown: true,
  dropdownMode: "select",
  placeholderText: "MM/DD/YYYY",
  dateFormat: "MM/dd/yyyy",
  //isClearable
  //closeOnScroll: true,
  //peekNextMonth:
};
export const ErrorMessages = {
  SAVE_ERROR: "Error occurred while saving.",
  LOAD_ERROR: "Error occurred while loading.",
  EMIAL_NONEXISTENT: "Email address does not exists.",
};

export const Role = {
  Admin: 1,
  Center: 2,
};
export const DatePart = {
  Day: 1,
  Month: 2,
  Year: 3
}
export const DayMonthUnknown = {
  DayUnk: 1,
  MonthUnk: 2,
  DayMonthUnk: 3
}
export const DefaultDate = "MM/DD/YYYY";

export const Values = {
  value0: 0, //instead of hardcode values using enums
  value1: 1,
  value2: 2,
  value3: 3,
  value4: 4,
  value5: 5,
  value6: 6,
  value7: 7,
  value8: 8,
  value9: 9,
  value10: 10,
  value11: 11,
  value12: 12,
  value13: 13,
  value14: 14,
  value15: 15,
  value16: 16,
  value17: 17,
  value18: 18,
  value19: 19,
  value20: 20,
  value21: 21,

  value31: 31,
  value32: 32,
  value91: 91,
  value92: 92,
  value99: 99,
  value273: 273,
  value365: 365,
  value456: 456,
  value457: 457,
  value548: 548,
  value639: 639,
  value821: 821,

  valu11point25: 11.25,
  value25: 25,
  value0point5: 0.5,
  value84: 84,
  value50: 50,
  value375: 375.0,
  value300: 300,
  value500: 500,
  value20000: 20000,
  value240000: 240000,
  value240: 240,
  value84000: 84000,
  value11000: 11000,
  value300000: 300000,

  value0point001: 0.001,
  value7point501: 7.501,
  value700:700,
    value1200: 1200,
    value1600: 1600,

}
// Values are the same as the radio btn values in Ven Ramp-up week page
export const WeeklyRegularDoseSchedule = {
  1: 2,
  2: 3,
  3: 4,
  4: 5,
  5: 6,
}
export const WeeklyModifiedDoseSchedule = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
}
export const StrongCYP3Agents = [
  "Clarithromycin",
  "Itraconazole",
  "Ketoconazole",
  "Posaconazole",
  "Ritonavir",
  "Voriconazole"
]

export const TLSMonitoringEnums = {
  max_radiographic_evaluations: 20,
};

export const LockType = {
  PatientLockPart1: 1,
  PatientLockPart2: 2,
  EligibilityCriteriaLock: 3
}

export const PatientStatus = {
  None: 1,
  Eligible: 2,
  Terminated: 3,
  Pending: 4
}

export const UrlType = {
  DataDictionary: 1,
  UserManual: 2
}